import * as React from 'react'
import Button from '@material-ui/core/Button'
import { gql, useQuery } from '@apollo/client'
/* import { Q_MEDIA_PATH } from 'graphql/query' */

import Stage from './Stage'
import styles from './designer.module.scss'
/* import Selection from 'components/ProductsPage/Selection' */
import apolloClient from '../../ApolloInstance'

import {
  DesignerGeoType,
  StagePropsType,
  StageStateType,
  selectionTree,
} from './Types'
// import MaterialContainer from './MaterialEditor/MaterialContainer'

interface Props {
  setTopBar: Function
}

enum Mode {
  SELECT,
  DESIGN,
  FINAL,
}

interface State {
  mode: Mode
  geo: DesignerGeoType[]
  mediaPath: string
  title: string
  selectionTree: selectionTree[]
}

class Designer extends React.Component<Props, State> {
  state: State = {
    mode: Mode.SELECT,
    geo: [],
    mediaPath: '',
    title: 'Select a model',
    selectionTree: [],
  }

  private setTopBar: Function

  constructor(props: Props) {
    super(props)
    this.setTopBar = props.setTopBar
  }

  componentDidMount = () => {
    apolloClient
      .query({
        query: gql`
          query {
            getMediaPath
          }
        `,
      })
      .then(res => this.setState({ mediaPath: res.data.getMediaPath }))
  }

  reset = () => {
    this.setTopBar(true)
    this.setState({ mode: Mode.SELECT, geo: [], title: 'Select a Model' })
  }

  /* setGeo = ({
   *   geo,
   *   title,
   *   sltData,
   * }: {
   *   geo: DesignerGeoType[]
   *   title: string
   *   sltData: selectionTree[]
   * }) => {
   *   this.setTopBar(false)
   *   this.setState({ mode: Mode.DESIGN, geo, title })
   *   this.setState({ selectionTree: sltData })
   * } */

  ModeSelect = () => {
    return (
      <div /* Selection UI */ className={styles.main_wrapper}>
        <Button
          variant="contained"
          className={styles.auto_setter}
          onClick={() => {
            this.setTopBar(false)
            const root = `/designer/sdmz/${'mazda--MX5'}/`
            this.setState({
              geo: [
                {
                  baked: `${root}baked_geo.glb`,
                  model: `${root}model.sdm`,
                  img: [
                    `${root}cam1.png`,
                    `${root}cam2.png`,
                    `${root}cam3.png`,
                  ],
                },
              ],
              mode: Mode.DESIGN,
              title: 'mazda--MX5',
            })
          }}
        >
          Select {'mazda--MX5'}
        </Button>
        <Button
          variant="contained"
          className={styles.auto_setter}
          onClick={() => {
            this.setTopBar(false)
            const root = `/designer/sdmz/mazda--MX5/`
            const root_dash = `/designer/sdmz/mazda--MX5--Dashboard/`
            const root_steer = `/designer/sdmz/mazda--MX5--Steering/`
            const root_p = `/designer/sdmz/MX5_pillion-mazda/`
            this.setState({
              geo: [
                {
                  baked: `${root}baked_geo.glb`,
                  model: `${root}model.sdm`,
                  img: [
                    `${root}cam1.png`,
                    `${root}cam2.png`,
                    `${root}cam3.png`,
                  ],
                },
                {
                  baked: `${root_dash}baked_geo.glb`,
                  model: `${root_dash}model.sdm`,
                  img: [
                    `${root_dash}cam1.png`,
                    `${root_dash}cam2.png`,
                    `${root_dash}cam3.png`,
                  ],
                },
                {
                  baked: `${root_steer}baked_geo.glb`,
                  model: `${root_steer}model.sdm`,
                  img: [
                    `${root_steer}cam1.png`,
                    `${root_steer}cam2.png`,
                    `${root_steer}cam3.png`,
                  ],
                },
                {
                  baked: `${root_p}baked_geo.glb`,
                  model: `${root_p}model.sdm`,
                  img: [
                    `${root_p}cam1.png`,
                    `${root_p}cam2.png`,
                    `${root_p}cam3.png`,
                  ],
                },
              ],
              mode: Mode.DESIGN,
              title: 'mazda--MX5',
            })
          }}
        >
          Select Mazda--MX5 + Dashboard + Steering
        </Button>
        <Button
          variant="contained"
          className={styles.auto_setter}
          onClick={() => {
            this.setTopBar(false)
            const root = `/designer/sdmz/${'smart_FORTWO'}/`
            this.setState({
              geo: [
                {
                  baked: `${root}baked_geo.glb`,
                  model: `${root}model.sdm`,
                  img: [
                    `${root}cam1.png`,
                    `${root}cam2.png`,
                    `${root}cam3.png`,
                  ],
                },
              ],
              mode: Mode.DESIGN,
              title: 'smart_FORTWO',
            })
          }}
        >
          Select Smart ForTwo
        </Button>
        <Button
          variant="contained"
          className={styles.auto_setter}
          onClick={() => {
            this.setTopBar(false)
            const root = `/designer/sdmz/Seat-Bike/`
            this.setState({
              geo: [
                {
                  baked: `${root}baked_geo.glb`,
                  model: `${root}model.sdm`,
                  img: [
                    `${root}cam1.png`,
                    `${root}cam2.png`,
                    `${root}cam3.png`,
                  ],
                },
              ],
              mode: Mode.DESIGN,
              title: 'Bike',
            })
          }}
        >
          Bike
        </Button>
        {/* <Selection setModel={this.setGeo} /> */}
      </div>
    )
  }

  ModeDesign = () => {
    return (
      <div /* Designer */ className={styles.main_wrapper}>
        <Stage
          title={this.state.title}
          geo={this.state.geo}
          mediaPath={this.state.mediaPath}
          reset={this.reset}
          selectionTree={this.state.selectionTree}
        ></Stage>
        {/* <div
          style={{
            backgroundImage: 'url(/StageBG.png)',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <MaterialContainer />
        </div> */}
      </div>
    )
  }

  ModeFinal = () => {
    return (
      <div /* Final Spec Sheet */ className={styles.main_wrapper}>Final</div>
    )
  }

  render = () => {
    switch (this.state.mode) {
      case Mode.SELECT:
        return this.ModeSelect()
      case Mode.DESIGN:
        return this.ModeDesign()
      case Mode.FINAL:
        return this.ModeFinal()
      default:
        return null
    }
  }
}

export default Designer
